import { ValueStorageService } from '../../shared/services/ValueStorageService';

export const RequestEmailService = new ValueStorageService<string>();
